const angular = require('angular');

const { ghostTileComponentDefinition } = require('./ghost-tile.component');
const { tileListComponentDefinition } = require('./tile-list.component');
const { tileComponentDefinition } = require('./tile.component');
const { sortByKeys } = require('./tile-list-sort-by-keys.constants');

angular.module('wowApp.shop')
    .constant('SortByKeys', sortByKeys)
    .component('wowGhostTile', ghostTileComponentDefinition)
    .component('wowTileList', tileListComponentDefinition)
    .component('wowTile', tileComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/tiles/index.js